import { Injectable, computed, signal } from '@angular/core';
import { Colors, DashboardModes, Desktop, LoginPageModes } from '../api/models';
import { AppThemeMode } from '../types/app-theme-mode.type';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  constructor() {}

  currentAppLang = signal<string>('fa');
  currentThemeMode = signal<AppThemeMode>('light');
  isLtr = signal<boolean>(false);
  showEnamad = signal<boolean>(true);
  refreshedTabName = signal<string>('dashboard');
  notificationDrawerToggle = signal<any>({});
  #organizationCredit = signal<number>(0);
  #userCredit = signal<number>(0);

  organizationCredit = computed(this.#organizationCredit);

  static currentAppLang = signal<string>('fa');
  static currentThemeMode = signal<AppThemeMode>('light');
  static serverDateTime: string;
  static backgroundImagePath: string;
  static appTheme: Desktop;
  static primaryColor: Colors;
  static secondaryColor: Colors;
  static loginPageMode: LoginPageModes;
  static header: string;
  static eNamad: string;
  static dashboardMode: DashboardModes;
  static sliderPicturePaths: null | Array<string>;

  setOrganizationCredit(credit: number) {
    this.#organizationCredit.set(credit);
  }

  setUserCredit(credit: number) {
    this.#userCredit.set(credit);
  }
}
